module.exports = __webpack_public_path__ + "static/img/fish26.e20313c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish26.png
// module id = e0+g
// module chunks = 0